import { AssetClass } from '../types/AssetClasses';

// Asset classes with hard-coded expected returns and volatilities
export const ASSET_CLASSES: AssetClass[] = [
  { id: 'USEquity', name: 'US Equity'},
  { id: 'InternationalEquity', name: 'International Equity'},
  { id: 'AggregateBonds', name: 'Aggregate Bonds'},
  { id: 'Cash', name: 'Cash'},
];

export const getAssetClassById = (id: string): AssetClass | undefined => {
  return ASSET_CLASSES.find(asset => asset.id === id);
};

